export function renderHeader(h, { column }, text) {
  const serviceContent = [];
  if (Array.isArray(text)) {
    text.map(item => {
      serviceContent.push(
        h(
          "div",
          {
            slot: "content"
          },
          item
        )
      );
    });
  } else {
    serviceContent.push(
      h(
        "div",
        {
          slot: "content"
        },
        text
      )
    );
  }
  return handleRenderHeader(h, { column }, serviceContent);
}

function handleRenderHeader(h, { column }, serviceContent) {
  return h("div", [
    h("span", column.label),
    h(
      "el-tooltip",
      {
        props: {
          placement: "bottom",
          class: "atooltip"
        }
      },
      [
        serviceContent,
        h("i", {
          class: "el-icon-warning-outline",
          style: "margin-left:5px"
        })
      ]
    )
  ]);
}
